import {
  ListWorkOrdersQuery,
  ListWorkOrdersResult,
  WorkorderColumnOrderConfig,
} from '@/core/domain/workorder/WorkOrders/WorkOrders.types';
import { tableSorterOrder } from '@/utils/table';
import { SorterResult } from 'antd/lib/table/interface';

export default function workorderOrderColumns(
  sorter: SorterResult<ListWorkOrdersResult>,
  setQueryParams: React.Dispatch<React.SetStateAction<ListWorkOrdersQuery>>,
) {
  if (sorter && sorter?.columnKey) {
    setQueryParams((prev) => {
      if (sorter && sorter?.columnKey) {
        const order = sorter.order
          ? tableSorterOrder[sorter.order] === 'ASC'
            ? 0
            : 1
          : 1;

        const orderColumns = sorter.order
          ? WorkorderColumnOrderConfig[sorter.columnKey]
          : undefined;

        if (prev.orderColumns === orderColumns) {
          return {
            ...prev,
            order,
          };
        }

        return {
          ...prev,
          order,
          orderColumns,
        };
      }

      return prev;
    });
  }
}
